export default __webpack_public_path__ + "static/media/groups-goalkeeper.0e3e47ff.svg";